import { Configuration } from 'store/configurations';
import { Kiosk } from 'store/kiosks';
import { ClientIntegration } from 'store/clientIntegrations';
import { Venue } from 'store/venues';
import { Hardware } from 'store/hardware';
import { KioskHardware } from 'store/kioskHardware';
import { Area } from 'store/areas';
import { Integration } from 'store/integrations';

export enum Selections {
  CLIENT_INTEGRATION = 'clientIntegration',
  KIOSK = 'kiosk',
  KIOSK_HARDWARE = 'kioskHardware',
  CONFIGURATION = 'configuration'
}

export type ConfigData = Configuration | Kiosk | ClientIntegration;

export type PropertyType =
  | boolean
  | number
  | string
  | TicketTemplateType
  | Venue
  | Integration
  | Configuration
  | ClientIntegration
  | Area
  | Hardware;

export interface ConfigurationsProps {
  configData: ConfigData;
  configType: string;
  columns: {
    key: string;
    type: string;
    children?: {
      key: string;
      type: string;
      children?: {
        key: string;
        type: string;
      }[];
    }[];
  }[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDeleteConfirm: (configType: string, payload: any) => void;
  setDrawerVisibility: (status: boolean) => void;
}

export type MappingRelation = KioskHardware;
export type MappingData = Hardware;

export interface ConfigMappingProps {
  kiosks: Kiosk[];
  mappingData: MappingData[];
  mappingType: 'kioskHardware';
  columns: {
    key: string;
    displayName: string;
    width?: string;
  }[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDeleteConfirm: (configType: string, payload: any) => void;
}

export interface ConfigEditDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  configData: ConfigData;
  selectedColumn: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedColumnValue: PropertyType | Record<string, any> | null | undefined;
  selectedProperty: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedPropertyValue: PropertyType | Record<string, any>;
  selectedSubProperty?: string;
  selectedDataType: string;
  configType: string;
  addConfigDropdown: {
    key: string;
    type: string;
  }[];
}

export interface MappingEditDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  configData: KioskHardware;
  configItem: Hardware;
  kiosk: Kiosk;
}

export interface ConfigUpdateDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  configData: ConfigData;
  configType?: string;
}

export interface ConfigUpdateFormProps {
  configData: ConfigData;
  configType?: string;
  columns: {
    key: string;
    type: string;
    children?: {
      key: string;
      type: string;
    }[];
  }[];
}

export interface ConfigCreateOverlayProps {
  kiosk?: Kiosk;
  selectedCI?: ClientIntegration;
  configType?: string;
  onConfirm?: () => void;
  onCancel: () => void;
}

export interface ConfigCreateFormProps {
  kiosk?: Kiosk;
  selectedCI?: ClientIntegration;
  loading: boolean;
  error?: string;
  resetError: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (payload: any) => void;
}

export type TemplateType = 'sale' | 'receipt' | 'test';

export interface TicketTemplateType {
  name: string;
  code: TemplateType;
}
